const SUPPORTED_BROWSERS = ['chrome', 'firefox', 'edge', 'edge-chromium', 'safari'];
const MOBILE_OPERATING_SYSTEMS = ['ios', 'android os', 'windows mobile', 'blackberry os'];

export {
  SUPPORTED_BROWSERS,
  MOBILE_OPERATING_SYSTEMS,
};
